module.exports = __webpack_public_path__ + "static/media/pray-icon.eca317df.png";